import { render, staticRenderFns } from "./Box3.vue?vue&type=template&id=7f1276c8&scoped=true&"
import script from "./Box3.vue?vue&type=script&lang=js&"
export * from "./Box3.vue?vue&type=script&lang=js&"
import style0 from "./Box3.vue?vue&type=style&index=0&id=7f1276c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1276c8",
  null
  
)

export default component.exports